<template>
  <section class="container mx-auto px-0 lg:px-3 mt-10">
    <div class="grid grid-cols-12 items-start gap-3">
      <div
        class="col-span-12 sm:col-span-12 lg:col-span-3 flex flex-col gap-5 mt-6"
      >
        <h4 v-if="!$route.params.id">
          {{ $t("labels.add", { pt: "Turma", en: "Class" }) }}
        </h4>

        <h4 v-else>
          {{ $t("labels.edit", { pt: "Turma", en: "Class" }) }}
        </h4>

        <div class="rounded-lg border border-gray-200 overflow-hidden mt-[8px]">
          <div class="flex flex-col w-100">
            <div
              v-for="(item, i) in buttons"
              :key="i"
              :class="`p-5 ${
                i == active
                  ? 'btn-tab-active'
                  : item.done || !item.off
                  ? 'btn-tab-done'
                  : 'btn-tab-gray'
              }`"
              :disabled="item.off"
            >
              <div class="flex justify-between items-center w-full">
                <span class="hover:scale-95 transition-all">
                  {{ item.title }}
                </span>
                <v-icon
                  v-if="item.done"
                  name="hi-solid-check-circle"
                  class="text-h-success-500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-span-12 sm:col-span-12 lg:col-span-9 flex flex-col gap-5"
        v-if="!loading"
      >
        <TabView class="custom-tabs-objective" :activeIndex="active">
          <TabPanel>
            <Info
              @onNext="changeTab(1)"
              @onAllow="allowSteps"
              :classroom="classroom"
            />
          </TabPanel>
          <TabPanel>
            <SelectUsers
              @onAllow="allowSteps"
              @onBack="changeTab(0)"
              :classroom="classroom"
            />
          </TabPanel>
        </TabView>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { GoToRoute } from "@/utils/go-to.util";
import { removeItemSessionStorage } from "@/utils/save-storage.util";
import { debounceTime } from "rxjs";
import { defineAsyncComponent, defineComponent } from "vue";
import { ClassesService } from "../classes.service";

const Info = defineAsyncComponent(() => import("./Info/info.vue"));
const SelectUsers = defineAsyncComponent(
  () => import("./SelectUsers/select-users.vue")
);

export default defineComponent({
  name: "formClasses",
  components: { Info, SelectUsers },
  computed: {
    service(): ClassesService {
      return new ClassesService();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  data() {
    return {
      active: 0,
      buttons: [
        {
          title: this.$t("classes.create.buttons.info"),
          active: 0,
          off: false,
          done: null,
        },
        {
          title: this.$t("classes.create.buttons.select"),
          active: 1,
          off: true,
          done: null,
        },
      ] as any,
      classId: "" as any,
      classroom: {} as any,
      loading: false as boolean,
    };
  },
  mounted() {
    this.classId = this.$route.params.id;
    this.getClassById();
  },
  updated() {
    this.active = Number(this.$route.params.tab) ?? 0;
    this.classId = this.$route.params.id;
    this.allowSteps(this.$route.params.id);
  },
  watch: {
    $route(val) {
      if (val.name !== "formClasses") removeItemSessionStorage("classData");
    },
  },
  methods: {
    getClassById(): void {
      if (this.$route.params.id) {
        this.loading = true;
        this.service.class.pipe(debounceTime(500)).subscribe({
          next: (response) => {
            if (!response) return;
            this.buttons.filter((e) => e.active === 0)[0].done = true;
            this.buttons.filter((e) => e.active === 1)[0].done = true;
            this.buttons.filter((e) => e.active === 1)[0].off = false;
            this.classroom = response;
            this.loading = false;
          },
        });
        this.service.getClassById(this.$route.params.id as string);
      }
    },
    changeTab(index: number): void {
      this.active = index;
      const params = {
        id: this.$route.params.id,
        tab: index,
      };
      this.go.redirectToPage("formClasses", params);
    },
    allowSteps(active: any): void {
      this.buttons.forEach((e) => {
        if (e.active === active) {
          e.done = true;
          e.off = false;
        }
      });
    },
  },
});
</script>
